<template>
    <el-transfer
        ref="transferRef"
        v-if="permissionsShow"
        v-model="currentValue"
        :data="data"
        :filterable="filterable"
        :filter-placeholder="$t(placeholder)"
        :titles="titles"
        :button-texts="buttonTexts"
        :left-default-checked="leftDefaultChecked"
        :right-default-checked="rightDefaultChecked"
        :props="props"
        :target-order="targetOrder"
        @filter-method="_filterMethod"
        @change="_change"
        @left-check-change="_leftCheckChange"
        @right-check-change="_rightCheckChange"
    >
        <template slot="left-footer">
            <slot name="left-footer"></slot>
        </template>
        <template slot="right-footer">
            <slot name="right-footer"></slot>
        </template>
    </el-transfer>
</template>
<script>
export default {
    props: {
        /* 右侧列表数据 key值集合 */
        value: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 数据源 */
        data: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 数据源的字段别名 */
        props: {
            type: Object,
            default: function() {
                return { key: 'key', label: 'label' };
            }
        },
        /* 禁用信息 key值 */
        disabledList: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 初始状态下左侧列表的已勾选项的 key 数组 */
        leftDefaultChecked: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 初始状态下右侧列表的已勾选项的 key 数组 */
        rightDefaultChecked: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 是否启用搜索框 */
        filterable: {
            type: Boolean,
            default: function() {
                return true;
            }
        },
        /* 默认显示搜索框占位符 */
        placeholder: {
            type: String,
            default: function() {
                return 'component.PLEASE_INPUT';
            }
        },
        /* 自定义表头文案 */
        titles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 自定义按钮文案 */
        buttonTexts: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 右侧列表元素的排序策略：若为 original，则保持与数据源相同的顺序；若为 push，则新加入的元素排在最后；
            若为 unshift，则新加入的元素排在最前 */
        targetOrder: {
            type: String,
            default: 'original'
        },
        /* 所有权限信息 */
        permissions: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 角色信息 */
        roles: {
            type: Array,
            default: function() {
                return [];
            }
        },
        /* 权限之一 */
        oneOfPermissions: {
            type: Array,
            default: function() {
                return [];
            }
        }
    },
    data() {
        return {
            /* 是否满足显示权限 */
            permissionsShow: true,
            currentValue: []
        };
    },
    watch: {
        value: {
            handler: function(val) {
                if (val.length == 0) {
                    this.currentValue = [];
                } else {
                    this.currentValue = val;
                }
            },
            deep: true
        }
    },
    mounted() {
        /* 初始化禁止操作的数据 */
        for (let i = 0; i < this.data.length; i++) {
            if (JSON.stringify(this.disabledList).indexOf(JSON.stringify(this.data[i][this.props.key])) > 0) {
                this.data[i].disabled = true;
            }
        }
    },
    created() {
        /* 权限数据处理 */
        if (this.permissions.length > 0 || this.oneOfPermissions.length > 0 || this.roles.length > 0) {
            this.permissionsShow = this.dealPermissions(this.permissions, this.roles, this.oneOfPermissions);
        }
        this.currentValue = eval(this.value);
    },
    methods: {
        /* 搜索事件的方法实现 */
        _filterMethod(query) {
            return this.data.indexOf(query) > -1;
        },
        /* 列表元素变化时触发 当前值、数据移动的方向（'left' / 'right'）、发生移动的数据 key 数组 */
        _change(value, direction, moveArray) {
            this.$emit('change', value, direction, moveArray);
            this.$emit('input', value);
        },
        /* 左侧列表元素被用户选中 / 取消选中时触发  当前被选中的元素的 key 数组、选中状态发生变化的元素的 key 数组 */
        _leftCheckChange(selectArray, changeArray) {
            this.$emit('leftCheckChange', selectArray, changeArray);
        },
        /* 右侧列表元素被用户选中 / 取消选中时触发  当前被选中的元素的 key 数组、选中状态发生变化的元素的 key 数组 */
        _rightCheckChange(selectArray, changeArray) {
            this.$emit('rightCheckChange', selectArray, changeArray);
        },
        /* 获取所有右侧数据 */
        getAllRightKeys() {
            return this.currentValue;
        },
        /* 清空某个面板的搜索关键词	'left' / 'right'，指定需要清空的面板 */
        clearQuery(val) {
            this.$refs.transferRef.clearQuery(val);
        },
        clean() {
            this.currentValue = [];
        }
    }
};
</script>
